module.exports = __webpack_public_path__ + "static/media/B-Suburbs.9eb77d27.png";